/**
 * Do not edit directly, this file was auto-generated.
 */

import { css } from 'styled-components';
export const cssVariables = css`
  --mlb-2-1-0-surface-surface0: var(--mlb-2-1-0-color-neutral-neutral100, #f4f5f6);
  --mlb-2-1-0-surface-surface1: var(--mlb-2-1-0-color-white, #ffffff);
  --mlb-2-1-0-surface-surface2: var(--mlb-2-1-0-color-white, #ffffff);
  --mlb-2-1-0-background-neutral: var(--mlb-2-1-0-color-neutral-neutral100, #f4f5f6);
  --mlb-2-1-0-background-inverse: var(--mlb-2-1-0-color-neutral-neutral1400, #070a0d);
  --mlb-2-1-0-background-emphasis-subtle: rgba(
    0,
    72,
    199,
    var(--mlb-2-1-0-opacity-opacity5, 0.05)
  ); /* Background color to emphasize items on surface. It uses color.blue.blue700 with opacity.5. */
  --mlb-2-1-0-background-emphasis-bold: var(
    --mlb-2-1-0-color-blue-blue700,
    #0048c7
  ); /* UI loaders/things that need to pass accessibility contrast on default/neutral surfaces */
  --mlb-2-1-0-background-alert: var(--mlb-2-1-0-color-red-red100, #ffd8d4);
  --mlb-2-1-0-background-positive: var(--mlb-2-1-0-color-green-green100, #d4edd3);
  --mlb-2-1-0-background-warning: var(--mlb-2-1-0-color-yellow-yellow100, #f7e0c8);
  --mlb-2-1-0-border-neutral-decorative: var(--mlb-2-1-0-color-neutral-neutral200, #e8eaed);
  --mlb-2-1-0-border-neutral-contrast: var(--mlb-2-1-0-color-neutral-neutral700, #7f8994);
  --mlb-2-1-0-border-inverse: var(--mlb-2-1-0-color-neutral-neutral1400, #070a0d);
  --mlb-2-1-0-border-emphasis: var(--mlb-2-1-0-color-blue-blue700, #0048c7);
  --mlb-2-1-0-border-alert: var(--mlb-2-1-0-color-red-red700, #aa0013);
  --mlb-2-1-0-border-positive: var(--mlb-2-1-0-color-green-green700, #006c00);
  --mlb-2-1-0-text-primary: var(--mlb-2-1-0-color-neutral-neutral1400, #070a0d);
  --mlb-2-1-0-text-secondary: var(--mlb-2-1-0-color-neutral-neutral900, #57606c);
  --mlb-2-1-0-text-inverse: var(--mlb-2-1-0-color-white, #ffffff);
  --mlb-2-1-0-text-action: var(--mlb-2-1-0-color-blue-blue700, #0048c7);
  --mlb-2-1-0-text-alert: var(--mlb-2-1-0-color-red-red700, #aa0013);
  --mlb-2-1-0-text-positive: var(--mlb-2-1-0-color-green-green700, #006c00);
  --mlb-2-1-0-text-warning: var(--mlb-2-1-0-color-yellow-yellow700, #8c3c00);
  --mlb-2-1-0-icon-primary: var(
    --mlb-2-1-0-color-neutral-neutral1300,
    #14191f
  ); /* passes 4.5:1 contrast on surface1/surface0 dark mode */
  --mlb-2-1-0-icon-secondary: var(
    --mlb-2-1-0-color-neutral-neutral900,
    #57606c
  ); /* passes 4.5:1 contrast on surface1/surface0 dark mode */
  --mlb-2-1-0-icon-decorative: var(
    --mlb-2-1-0-color-neutral-neutral700,
    #7f8994
  ); /* passes 3:1 contrast on surface1/surface0 dark mode */
  --mlb-2-1-0-icon-inverse: var(--mlb-2-1-0-color-white, #ffffff);
  --mlb-2-1-0-icon-action: var(--mlb-2-1-0-color-blue-blue700, #0048c7);
  --mlb-2-1-0-icon-alert: var(--mlb-2-1-0-color-red-red700, #aa0013);
  --mlb-2-1-0-icon-positive: var(--mlb-2-1-0-color-green-green700, #006c00);
  --mlb-2-1-0-icon-warning: var(--mlb-2-1-0-color-yellow-yellow700, #8c3c00);
  --mlb-2-1-0-static-black: var(--mlb-2-1-0-color-black, #000000);
  --mlb-2-1-0-static-white: var(--mlb-2-1-0-color-white, #ffffff);
  --mlb-2-1-0-static-border-highlight: rgba(255, 255, 255, var(--mlb-2-1-0-opacity-opacity20, 0.2));
  --mlb-2-1-0-static-overlay-default: rgba(0, 0, 0, var(--mlb-2-1-0-opacity-opacity40, 0.4));
  --mlb-2-1-0-static-overlay-bold: rgba(0, 0, 0, var(--mlb-2-1-0-opacity-opacity70, 0.7));
  --mlb-2-1-0-static-background-action: var(
    --mlb-2-1-0-color-blue-blue700,
    #0048c7
  ); /* Primary CTA button backgrounds */
  --mlb-2-1-0-static-background-alert: var(--mlb-2-1-0-color-red-red700, #aa0013); /* "Live" or “Breaking News” Tags */
  --mlb-2-1-0-static-accent-blue-light: var(--mlb-2-1-0-color-blue-blue200, #a4cdff);
  --mlb-2-1-0-static-accent-blue-dark: var(--mlb-2-1-0-color-blue-blue600, #0062e3);
  --mlb-2-1-0-static-accent-red-light: var(--mlb-2-1-0-color-red-red200, #ffb3ad);
  --mlb-2-1-0-static-accent-red-dark: var(--mlb-2-1-0-color-red-red600, #c61b2b);
  --mlb-2-1-0-static-accent-green-light: var(--mlb-2-1-0-color-green-green200, #acdaa9);
  --mlb-2-1-0-static-accent-green-dark: var(--mlb-2-1-0-color-green-green600, #098314);
  --mlb-2-1-0-static-accent-yellow-light: var(--mlb-2-1-0-color-yellow-yellow200, #edc394);
  --mlb-2-1-0-static-accent-yellow-dark: var(--mlb-2-1-0-color-yellow-yellow600, #a65400);
  --mlb-2-1-0-static-accent-purple-light: var(--mlb-2-1-0-color-purple-purple200, #d0c2f3);
  --mlb-2-1-0-static-accent-purple-dark: var(--mlb-2-1-0-color-purple-purple600, #7756b3);
  --mlb-2-1-0-state-hover: rgba(
    7,
    10,
    13,
    var(--mlb-2-1-0-opacity-opacity5, 0.05)
  ); /* Background color for items on surface in a pressed state. It uses color.onSurface.primary with opacity.10 */
  --mlb-2-1-0-state-pressed: rgba(
    7,
    10,
    13,
    var(--mlb-2-1-0-opacity-opacity10, 0.1)
  ); /* Background overlay for button in a pressed state. */
  --mlb-2-1-0-state-skeleton-background: var(--mlb-2-1-0-color-neutral-neutral300, #dbdfe3);
  --mlb-2-1-0-state-skeleton-overlay: var(--mlb-2-1-0-color-neutral-neutral400, #c3c8cf);
  --mlb-2-1-0-shadow-shadow-small-blur: 16px; /* for top app bar and bottom nav bar */
  --mlb-2-1-0-shadow-shadow-small-spread: 0; /* for top app bar and bottom nav bar */
  --mlb-2-1-0-shadow-shadow-small-color: rgba(0, 0, 0, 0.08); /* for top app bar and bottom nav bar */
  --mlb-2-1-0-shadow-shadow-small-type: dropShadow; /* for top app bar and bottom nav bar */
  --mlb-2-1-0-shadow-shadow-small-offset-x: 0; /* for top app bar and bottom nav bar */
  --mlb-2-1-0-shadow-shadow-small-offset-y: 0; /* for top app bar and bottom nav bar */
  --mlb-2-1-0-shadow-shadow-medium-blur: 24px; /* toasts  */
  --mlb-2-1-0-shadow-shadow-medium-spread: 0; /* toasts  */
  --mlb-2-1-0-shadow-shadow-medium-color: rgba(0, 0, 0, 0.08); /* toasts  */
  --mlb-2-1-0-shadow-shadow-medium-type: dropShadow; /* toasts  */
  --mlb-2-1-0-shadow-shadow-medium-offset-x: 0; /* toasts  */
  --mlb-2-1-0-shadow-shadow-medium-offset-y: 1px; /* toasts  */
  --mlb-2-1-0-shadow-shadow-large-blur: 32px; /* carded components */
  --mlb-2-1-0-shadow-shadow-large-spread: 0; /* carded components */
  --mlb-2-1-0-shadow-shadow-large-color: rgba(0, 0, 0, 0.08); /* carded components */
  --mlb-2-1-0-shadow-shadow-large-type: dropShadow; /* carded components */
  --mlb-2-1-0-shadow-shadow-large-offset-x: 0; /* carded components */
  --mlb-2-1-0-shadow-shadow-large-offset-y: 10px; /* carded components */
  --mlb-2-1-0-gradient-fade-subtle-start: var(--mlb-2-1-0-color-neutral-neutral100, #f4f5f6); /* Gradient start value */
  --mlb-2-1-0-gradient-fade-subtle-end: rgba(244, 245, 246, 0); /* Gradient end value */
  --mlb-2-1-0-gradient-fade-subtle: linear-gradient(
    var(--mlb-2-1-0-gradient-fade-subtle-start, #f4f5f6) 0%,
    var(--mlb-2-1-0-gradient-fade-subtle-end, rgba(244, 245, 246, 0)) 100%
  );
  --mlb-2-1-0-gradient-fade-subtle-90: linear-gradient(
    90deg,
    var(--mlb-2-1-0-gradient-fade-subtle-start, #f4f5f6) 0%,
    var(--mlb-2-1-0-gradient-fade-subtle-end, rgba(244, 245, 246, 0)) 100%
  );
  --mlb-2-1-0-gradient-fade-subtle-180: linear-gradient(
    180deg,
    var(--mlb-2-1-0-gradient-fade-subtle-start, #f4f5f6) 0%,
    var(--mlb-2-1-0-gradient-fade-subtle-end, rgba(244, 245, 246, 0)) 100%
  );
  --mlb-2-1-0-gradient-fade-subtle-270: linear-gradient(
    270deg,
    var(--mlb-2-1-0-gradient-fade-subtle-start, #f4f5f6) 0%,
    var(--mlb-2-1-0-gradient-fade-subtle-end, rgba(244, 245, 246, 0)) 100%
  );
`;
export const theme = {
  'surface/surface0': 'var(--mlb-2-1-0-surface-surface0)',
  'surface/surface1': 'var(--mlb-2-1-0-surface-surface1)',
  'surface/surface2': 'var(--mlb-2-1-0-surface-surface2)',
  'background/neutral': 'var(--mlb-2-1-0-background-neutral)',
  'background/inverse': 'var(--mlb-2-1-0-background-inverse)',
  'background/emphasis-subtle': 'var(--mlb-2-1-0-background-emphasis-subtle)',
  'background/emphasis-bold': 'var(--mlb-2-1-0-background-emphasis-bold)',
  'background/alert': 'var(--mlb-2-1-0-background-alert)',
  'background/positive': 'var(--mlb-2-1-0-background-positive)',
  'background/warning': 'var(--mlb-2-1-0-background-warning)',
  'border/neutral-decorative': 'var(--mlb-2-1-0-border-neutral-decorative)',
  'border/neutral-contrast': 'var(--mlb-2-1-0-border-neutral-contrast)',
  'border/inverse': 'var(--mlb-2-1-0-border-inverse)',
  'border/emphasis': 'var(--mlb-2-1-0-border-emphasis)',
  'border/alert': 'var(--mlb-2-1-0-border-alert)',
  'border/positive': 'var(--mlb-2-1-0-border-positive)',
  'text/primary': 'var(--mlb-2-1-0-text-primary)',
  'text/secondary': 'var(--mlb-2-1-0-text-secondary)',
  'text/inverse': 'var(--mlb-2-1-0-text-inverse)',
  'text/action': 'var(--mlb-2-1-0-text-action)',
  'text/alert': 'var(--mlb-2-1-0-text-alert)',
  'text/positive': 'var(--mlb-2-1-0-text-positive)',
  'text/warning': 'var(--mlb-2-1-0-text-warning)',
  'icon/primary': 'var(--mlb-2-1-0-icon-primary)',
  'icon/secondary': 'var(--mlb-2-1-0-icon-secondary)',
  'icon/decorative': 'var(--mlb-2-1-0-icon-decorative)',
  'icon/inverse': 'var(--mlb-2-1-0-icon-inverse)',
  'icon/action': 'var(--mlb-2-1-0-icon-action)',
  'icon/alert': 'var(--mlb-2-1-0-icon-alert)',
  'icon/positive': 'var(--mlb-2-1-0-icon-positive)',
  'icon/warning': 'var(--mlb-2-1-0-icon-warning)',
  'static/black': 'var(--mlb-2-1-0-static-black)',
  'static/white': 'var(--mlb-2-1-0-static-white)',
  'static/border/highlight': 'var(--mlb-2-1-0-static-border-highlight)',
  'static/overlay/default': 'var(--mlb-2-1-0-static-overlay-default)',
  'static/overlay/bold': 'var(--mlb-2-1-0-static-overlay-bold)',
  'static/background/action': 'var(--mlb-2-1-0-static-background-action)',
  'static/background/alert': 'var(--mlb-2-1-0-static-background-alert)',
  'static/accent/blue-light': 'var(--mlb-2-1-0-static-accent-blue-light)',
  'static/accent/blue-dark': 'var(--mlb-2-1-0-static-accent-blue-dark)',
  'static/accent/red-light': 'var(--mlb-2-1-0-static-accent-red-light)',
  'static/accent/red-dark': 'var(--mlb-2-1-0-static-accent-red-dark)',
  'static/accent/green-light': 'var(--mlb-2-1-0-static-accent-green-light)',
  'static/accent/green-dark': 'var(--mlb-2-1-0-static-accent-green-dark)',
  'static/accent/yellow-light': 'var(--mlb-2-1-0-static-accent-yellow-light)',
  'static/accent/yellow-dark': 'var(--mlb-2-1-0-static-accent-yellow-dark)',
  'static/accent/purple-light': 'var(--mlb-2-1-0-static-accent-purple-light)',
  'static/accent/purple-dark': 'var(--mlb-2-1-0-static-accent-purple-dark)',
  'state/hover': 'var(--mlb-2-1-0-state-hover)',
  'state/pressed': 'var(--mlb-2-1-0-state-pressed)',
  'state/skeleton-background': 'var(--mlb-2-1-0-state-skeleton-background)',
  'state/skeleton-overlay': 'var(--mlb-2-1-0-state-skeleton-overlay)',
  'shadow/shadow-small/blur': 'var(--mlb-2-1-0-shadow-shadow-small-blur)',
  'shadow/shadow-small/spread': 'var(--mlb-2-1-0-shadow-shadow-small-spread)',
  'shadow/shadow-small/color': 'var(--mlb-2-1-0-shadow-shadow-small-color)',
  'shadow/shadow-small/type': 'var(--mlb-2-1-0-shadow-shadow-small-type)',
  'shadow/shadow-small/offsetX': 'var(--mlb-2-1-0-shadow-shadow-small-offset-x)',
  'shadow/shadow-small/offsetY': 'var(--mlb-2-1-0-shadow-shadow-small-offset-y)',
  'shadow/shadow-medium/blur': 'var(--mlb-2-1-0-shadow-shadow-medium-blur)',
  'shadow/shadow-medium/spread': 'var(--mlb-2-1-0-shadow-shadow-medium-spread)',
  'shadow/shadow-medium/color': 'var(--mlb-2-1-0-shadow-shadow-medium-color)',
  'shadow/shadow-medium/type': 'var(--mlb-2-1-0-shadow-shadow-medium-type)',
  'shadow/shadow-medium/offsetX': 'var(--mlb-2-1-0-shadow-shadow-medium-offset-x)',
  'shadow/shadow-medium/offsetY': 'var(--mlb-2-1-0-shadow-shadow-medium-offset-y)',
  'shadow/shadow-large/blur': 'var(--mlb-2-1-0-shadow-shadow-large-blur)',
  'shadow/shadow-large/spread': 'var(--mlb-2-1-0-shadow-shadow-large-spread)',
  'shadow/shadow-large/color': 'var(--mlb-2-1-0-shadow-shadow-large-color)',
  'shadow/shadow-large/type': 'var(--mlb-2-1-0-shadow-shadow-large-type)',
  'shadow/shadow-large/offsetX': 'var(--mlb-2-1-0-shadow-shadow-large-offset-x)',
  'shadow/shadow-large/offsetY': 'var(--mlb-2-1-0-shadow-shadow-large-offset-y)',
  'gradient/fade-subtle-start': 'var(--mlb-2-1-0-gradient-fade-subtle-start)',
  'gradient/fade-subtle-end': 'var(--mlb-2-1-0-gradient-fade-subtle-end)',
  'gradient/fade-subtle': 'var(--mlb-2-1-0-gradient-fade-subtle)',
  'gradient/fade-subtle-90': 'var(--mlb-2-1-0-gradient-fade-subtle-90)',
  'gradient/fade-subtle-180': 'var(--mlb-2-1-0-gradient-fade-subtle-180)',
  'gradient/fade-subtle-270': 'var(--mlb-2-1-0-gradient-fade-subtle-270)',
};
